import { create, listByAuthUser, update } from 'src/repositories/bank-account.repository';

/**
 * Action Types
 */
export const BANK_ACCOUNT_CREATED = 'BANK_ACCOUNT_CREATED';
export const AUTH_USER_BANK_ACCOUNTS_LOADED = 'AUTH_USER_BANK_ACCOUNTS_LOADED';
export const BANK_ACCOUNT_UPDATED = 'BANK_ACCOUNT_UPDATED';

/**
 * Action Creators
 */
export const createdBankAccount = bankAccount => ({
    type: BANK_ACCOUNT_CREATED,
    payload: bankAccount,
});

export const loadedAuthUserBankAccounts = bankAccounts => ({
    type: AUTH_USER_BANK_ACCOUNTS_LOADED,
    payload: bankAccounts,
});

export const updatedBankAccount = bankAccount => ({
    type: BANK_ACCOUNT_UPDATED,
    payload: bankAccount,
});

/**
 * Actions
 */

/**
 * Create new bank account
 * @param {object} params
 */
export const createBankAccount = params => dispatch => create(params)
    .then(({ data }) => dispatch(createdBankAccount(data)));


/**
 * Load all bank accounts for authenticated user
 */
export const loadBankAccountsByAuthUser = () => dispatch => listByAuthUser()
    .then(({ data }) => dispatch(loadedAuthUserBankAccounts(data)));

/**
 * Update specific bank account
 */
export const updateBankAccount = (pkBankAccount, params) => dispatch => update(pkBankAccount, params)
    .then(({ data }) => dispatch(updatedBankAccount(data)));
